export enum Region {
  APA = 'APA',
  EU = 'EU',
  APS = 'APS',
  APN = 'APN',
}
